import React from 'react';

const SkillCrtl = () => (
	<div className="btn-wrap skl-ctrl hide-on-small-only">
		<button className="btn btn-floating waves-effect waves-light btn-large brand-bg white-text go go-left">
			<i className="mdi mdi-chevron-left"/>
		</button>
		<button className="btn btn-floating waves-effect waves-light btn-large brand-bg white-text go go-right">
			<i className="mdi mdi-chevron-right"/>
		</button>
	</div>
);

export default SkillCrtl;



// WEBPACK FOOTER //
// ./src/components/elements/Skill/SkillCrtl.js